import React from 'react';

type StatusType =
  | 'confirmed' |'pending' |'in-progress' |'completed' |'cancelled' |'enquiry' |'on-request' |'waitlist' |'active' |'inactive' |'processing' |'paid' |'overdue';

interface StatusBadgeProps {
  status: StatusType;
  size?: 'sm' | 'md';
  dot?: boolean;
}

const statusConfig: Record<StatusType, { label: string; className: string; dotColor: string }> = {
  confirmed: { label: 'Confirmed', className: 'status-confirmed', dotColor: '#74C69D' },
  pending: { label: 'Pending', className: 'status-pending', dotColor: '#F4A261' },
  'in-progress': { label: 'In Progress', className: 'status-in-progress', dotColor: '#5FA8D3' },
  completed: { label: 'Completed', className: 'status-completed', dotColor: '#C9A84C' },
  cancelled: { label: 'Cancelled', className: 'status-cancelled', dotColor: '#E76F51' },
  enquiry: { label: 'Enquiry', className: 'status-enquiry', dotColor: '#8892A4' },
  'on-request': { label: 'On Request', className: 'status-enquiry', dotColor: '#8892A4' },
  waitlist: { label: 'Waitlist', className: 'status-pending', dotColor: '#F4A261' },
  active: { label: 'Active', className: 'status-confirmed', dotColor: '#74C69D' },
  inactive: { label: 'Inactive', className: 'status-cancelled', dotColor: '#E76F51' },
  processing: { label: 'Processing', className: 'status-in-progress', dotColor: '#5FA8D3' },
  paid: { label: 'Paid', className: 'status-completed', dotColor: '#C9A84C' },
  overdue: { label: 'Overdue', className: 'status-cancelled', dotColor: '#E76F51' },
};

export default function StatusBadge({ status, size = 'md', dot = true }: StatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig.enquiry;
  const sizeClass = size === 'sm' ? 'text-2xs px-2 py-0.5' : 'text-xs px-2.5 py-1';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClass} ${config.className}`}>
      {dot && (
        <span
          className="w-1.5 h-1.5 rounded-full flex-shrink-0"
          style={{ backgroundColor: config.dotColor }}
        />
      )}
      {config.label}
    </span>
  );
}